
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Instantly authenticate your customer's accounts to use with Bakkt Fiat Services API for ACH based money movement"
};
export const partnerProps = {
  partner: 'Bakkt',
  clientLibrary: 'bakkt',
  subtitle: metadata.description,
  registrationUrl: 'https://bakkt.readme.io',
  apiUrl: 'https://bakkt.readme.io/reference/generateaccesstoken',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Bakkt® offers institutional-grade custody, trading, and onramp solutions for businesses to activate crypto strategies for their users. Bakkt's APIs power crypto trading in your business's front-end environment, allowing your business to offer users the ability to buy, sell, and hold crypto.`}</p>
    <br />
Bakkt makes it easy, fast and secure to offer crypto trading by leveraging Plaid Link:
    <br />
    <ol>
      <li parentName="ol">{`Use the Plaid Link drop-in UI to instantly connect and authenticate user bank accounts. This generates a processor token on behalf of each user.`}</li>
      <li parentName="ol">{`Set up Bakkt's APIs, which use Plaid Link's processor token to retrieve bank account details directly from Plaid. This layered integration enables a seamless workflow to connect the users' bank accounts to Bakkt to fund crypto trading.`}</li>
    </ol>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
